/*eslint-disable */
const $ = window.jQuery = require('jquery');

import allClearTrashPaper from '@/components/researchPapers/clear-all-trash';
import axios from 'axios';
import {
  bus
} from '@/main';
import {
mapGetters,
} from 'vuex';
import trashPaperRestore from '@/components/researchPapers/trash-paper-restore';
export default {
  name: 'trash-paper-list',
  components: {
    'paper-restore':trashPaperRestore,
    'all-clear-trash-paper':allClearTrashPaper
  },
  props: [],
  data () {
    return {
      paperPileDetails:null,
      paperPileResults:[],
      nextPageUrl:'',
      nextSteper:'',
      userLoading:false,
      trashPaperRestoreState:false,
      trashPaperId:'',
      trashFolderData:null,
      trashFolderListResults:[],
      trashItemName:'',
      clearAllTrshPaperState:false
    }
  },
  computed: {
    ...mapGetters([
      'getTrashaperListGetters',
      'getTrashFolderListGetters'
    ]),
    getPaperPileDetails(){
      this.paperPileDetails = this.$store.getters.getTrashaperListGetters.data;
      return
    },
    getPaperPileResultsIntialsState(){
      if(this.paperPileDetails){
        this.nextPageUrl = this.paperPileDetails.next
        this.nextSteper = this.paperPileDetails.next
        this.paperPileResults = [].concat(this.paperPileDetails.results)
      }
      return
    },
    getTrashFolderData(){
      this.trashFolderData = this.$store.getters.getTrashFolderListGetters.data;
      return
    },
    getTrashFolderIntialsState(){
      if(this.trashFolderData){
        this.trashFolderListResults = [].concat(this.trashFolderData.results)
      }
      return
    },
  },
  mounted () {
    this.getPaperPileDetails
    this.getPaperPileResultsIntialsState
    this.getTrashFolderData
    this.getTrashFolderIntialsState
    bus.$on('trashPaperRestoreStateBus', (data) => {
      this.trashPaperRestoreState = data;
    });
    bus.$on('clearAllTrshPaperBus', (data) => {
      this.clearAllTrshPaperState = data;
    });
  },
  methods: {
    allClearTrashPaperMethod(){
      this.clearAllTrshPaperState = true
      $('body').addClass('body_right_scroll_remove')
    },
    trashPaperRestoreMethod(ID, ItemName){
      this.trashItemName = ItemName
      this.trashPaperId = ID
      this.trashPaperRestoreState = true
      $('body').addClass('body_right_scroll_remove')
    },
    showLoadMoreDataFun(url) {
      this.userLoading = true
      axios.get(url).then((response) => {
          this.nextSteper = response.data.data.next
          this.paperPileResults = [].concat(this.paperPileResults,response.data.data.results);
          this.userLoading = false
        });
    },
  },
  watch:{
    getPaperPileDetails(){
      return this.$store.getters.getTrashaperListGetters;
    },
    getPaperPileResultsIntialsState(){
      if(this.paperPileDetails != undefined){
        this.nextPageUrl = this.paperPileDetails.next
        this.paperPileResults = [].concat(this.paperPileDetails.results)
      }
      return
    },
    nextSteper(old_val, new_val){
      if(old_val != ''){
        this.nextPageUrl = old_val
      }
    },
    getTrashFolderData(){
      return this.$store.getters.getTrashFolderListGetters
    },
    getTrashFolderIntialsState(){
      if(this.trashFolderData){
        this.trashFolderListResults = [].concat(this.trashFolderData.results)
      }
      return
    },
  },
}